import React from "react";
import { TSCard } from "@/components/shared/card/Card";

interface DeleteModalProps {
  visible: boolean;

  /** Modal title text */
  title: string;

  /** Confirmation message */
  message: string;

  /** Confirm button label */
  confirmLabel: string;

  /** Cancel button label */
  cancelLabel: string;

  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
  visible,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <TSCard className="p-6 w-[400px]">
        <h2 className="text-lg font-bold mb-4">{title}</h2>

        <p className="mb-6">
          {message}
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            {confirmLabel}
          </button>
        </div>
      </TSCard>
    </div>
  );
};